import { ElMessage } from 'element-plus';
import { debounce } from '@wakeadmin/utils';
import { getGlobalI18n } from '@wakeadmin/i18n';
import { Composer } from 'vue-i18n';

import { getAsset } from './services';

export const gotoLogin = debounce(
  () => {
    const i18n = getGlobalI18n();
    ElMessage.error(i18n.t('bay.sessionExpired'));
    window.setTimeout(() => {
      const LOGIN_URL = getAsset('URL_LOGIN', '/login.html');
      window.location.assign(`${LOGIN_URL}?url=${window.encodeURIComponent(window.location.href)}`);
    }, 700);
  },
  3000,
  { leading: true }
);

export const gotoChooseApp = debounce(
  () => {
    const CHOOSE_APP_URL = getAsset('URL_CHOOSE_APP', '/app.html');
    window.location.assign(CHOOSE_APP_URL);
  },
  3000,
  { leading: true }
);

export function getMenuI18nKey(path: string) {
  return `menu.${path}$`;
}

export function useT() {
  const global = getGlobalI18n();
  // @ts-expect-error
  return global.__composer.t as Composer['t'];
}

export function throwErrorIfNeedAfterSettled(...list: PromiseSettledResult<any>[]) {
  for (const item of list) {
    if (item.status === 'rejected') {
      throw item.reason;
    }
  }
}
